import AttendeeAction from './attendeeAction';
import Attendee from '../../../models/attendeeModel';
import SwapSessionPostAction from '../post-action/swapSessionPostAction';

export default class SwapSessionAction extends AttendeeAction {
    static NAME = 'swap_session';
    static POST_ACTION_COMPONENT = SwapSessionPostAction;

    constructor({ items, sync, onClose, organization, event, currentSessionDate }) {
        super({ items, sync, onClose, organization, event });
        this.currentSessionDate = currentSessionDate;
    }

    static condition(attendee) {
        return ['valid'].includes(attendee.order.status) && !attendee.removed;
    }

    static is_available({ event }) {
        return event.isUseSessionsNoSeated();
    }

    get is_direct() {
        return true;
    }

    // global
    get needs_confirm() {
        return false;
    }

    // simple
    get needs_selection() {
        return false;
    }

    run() {
        return Promise.resolve(true);
    }

    runPostAction(form) {
        return Attendee.perform_action(this.constructor.NAME, form, { organization: this.organization, event: this.event });
    }

    get post_action() {
        return true;
    }

    onActionDone() {
        this.onClose();
    }
}
